// General SVGs
export { default as planBgDark } from "./general/plan_bg-dark.png";
export { default as planBg } from "./general/plan_bg.png";
export { default as lightModeIcon } from "./general/sun-01.svg";
export { default as darkModeIcon } from "./general/moon-01.svg";
export { default as darkModeIconWhite } from "./general/moon-white-copy.svg";
export { default as editIconCircleBlue } from "./general/edit-icon-circle-blue.svg";
export { default as downloadFileIconV2 } from "./general/download-file-icon-v2.svg";
export { default as profileOfflineIcon } from "./general/profile-offline-icon.svg";
export { default as dotsMenuIcon } from "./general/menu-dots-icon.png";
export { default as upgradeIcon } from "./general/upgrade-icon.svg";
export { default as eyeIconOpen } from "./general/eye-orange-open.svg";
export { default as eyeIconClose } from "./general/eye-icon-close.svg";
export { default as infoIcon } from "./general/info-icon.svg";
export { default as infoIconDark } from "./general/info-icon-dark.svg";
export { default as userIconDark } from "./general/user-icon-dark.svg";
export { default as userIconLight } from "./general/user-icon-light.svg";
export { default as sustainableLeafIcon } from "./general//sustainable-leaf-icon.svg";
export { default as searchIconConnect } from "./general/search_icon.svg";
export { default as submitIconConnect } from "./general/Submit-Icon.svg";
export { default as cancelCircleBlack } from "./general/cancel_icon_crircle_black.svg";
export { default as faceBookCircleOrange } from "./general/facebook-orange-circle.svg";
export { default as linkedInLinkCircleOrange } from "./general/linkedIn-circle-orange.svg";
export { default as CopyLinkCircleOrange } from "./general/copy-link-orange.svg";
export { default as XCircleOrange } from "./general/X-circle-orange.svg";
export { default as whatsappCircleOrange } from "./general/whatsapp-circle-orange.svg";
export { default as pinBlack } from "./general/pin_black_icon.svg";
export { default as pinBlue } from "./general/pin_blue_icon.svg";
export { default as moveIconWhitBlue } from "./general/move_icon_white.svg";
export { default as closeOrangBorderIcon } from "./general/close_orange_border.svg";
export { default as closeOrangBorderIconDark } from "./general/close_orange_border-dark.svg";
export { default as trashIconCircleOrange } from "./general/trash_icon_circle_orange.svg";
export { default as trashIconCircleOrangeDark } from "./general/trash_icon_circle_orange_dark.svg";
export { default as RestoreIcon } from "./general/restore_icon.svg";
export { default as TrashOrange } from "./general/trash_orange.svg";
export { default as FolderBlackIcon } from "./general/folder-black.svg";
export { default as chakMarkWhite } from "./general/check-mark-icon-white.svg";
export { default as deleteIconBlue } from "./general/delete_icon_blue.svg";
export { default as deleteIconCircleOrange } from "./general/delete_orange_icon.svg";
export { default as uploadIconBlack } from "./general/upload_icon_black.svg";
export { default as bookmark_black } from "./general/bookmark_black.svg";
export { default as suitCase_black } from "./general/suitCase_black.svg";
export { default as starBlack } from "./general/star_black.svg";
export { default as employeesBlack } from "./general/Employees_black.svg";
export { default as addIcon } from "./general/add-icon.svg";
export { default as globeOrange } from "./general/globe_orange.svg";
export { default as facebookOrange } from "./general/facebook_orange.svg";
export { default as instaOrange } from "./general/insta_orange.svg";
export { default as stayTunedSvg } from "./general/stay-tuned-icon.svg";
export { default as stayTunedSvgDark } from "./general/stay-tuned-icon-dark.png";
export { default as loadingState } from "./general/loading-state-icon.svg";
export { default as editConnectIcon } from "./general/edit-connect-icon.svg";
export { default as getVerifiedWhite } from "./general/get-verified-icon-white.svg";
export { default as downloadFileIcon } from "./general/download-file-icon.png";
export { default as dropdownBlueIcon } from "./general/dropdown_icon_blue.svg";
export { default as modalClose } from "./general/modal_close.svg";
export { default as plusicon } from "./general/plus-icon.svg";
export { default as checkMarkOrange } from "./general/check_mark_orange.svg";
export { default as confirmationSvg } from "./general/confirmation.svg";
export { default as confirmationSvgDark } from "./general/confirmation-dark.png";
export { default as waitIcon } from "./general/wait_icon.svg";
export { default as waitIconDark } from "./general/waiting-dark-mode.png";
export { default as whitelogo } from "./general/white-logo.svg";
export { default as prologo } from "./general/archinza-pro-logo.svg";
export { default as prologoblack } from "./general/archinza-pro-logo-black.svg";
export { default as blacklogo } from "./general/archinza-logo-black.svg";
export { default as blacklogoBusiness } from "./general/archinza-business-logo.svg";
export { default as archinzaBusinessDeskWhite } from "./general/archinza-buss-white.svg";
export { default as archinzaBusinessDesk } from "./general/archinza-buss-logo-desk.svg";
export { default as fbHeader } from "./general/fb-icon.svg";
export { default as fbHeaderB } from "./general/fb-black.svg";
export { default as instaHeader } from "./general/insta-icon.svg";
export { default as instaHeaderB } from "./general/insta-black.svg";
export { default as linkedinHeader } from "./general/linkedin-icon.svg";
export { default as linkedinHeaderB } from "./general/linkedin-black.svg";
export { default as blackright } from "./general/black-right-arrow.svg";
export { default as loginicon } from "./general/login-icon.svg";
export { default as dropdownarrow } from "./general/dropdown-arrow.svg";
export { default as rightarrowwhite } from "./general/right-arrow-white.svg";
export { default as rightarrowblack } from "./general/right-arrow-black.svg";
export { default as deleteicon } from "./general/delete-icon.svg";
export { default as blackDeleteicon } from "./general/black-delete-icon.svg";
export { default as websiteicon } from "./general/website-icon.svg";
export { default as formfb } from "./general/formfb-icon.svg";
export { default as forminsta } from "./general/forminsta-icon.svg";
export { default as formupload } from "./general/cloud_upload.svg";
export { default as formLinkedin } from "./general/formLinkedin.svg";
export { default as formBehance } from "./general/formBehance.svg";
export { default as instaWhite } from "./general/forminsta-white.svg";
export { default as checkicon } from "./general/check-icon.svg";
export { default as checkiconWhite } from "./general/check-icon-white.svg";
export { default as otpicon } from "./general/otp-icon.svg";
export { default as protag } from "./general/pro-tag.png";
export { default as protagDark } from "./general/pro-tag-dark.svg";
export { default as protagLight } from "./general/pro-tag-light.svg";
export { default as accPlusIcon } from "./general/plusIcon.svg";
export { default as accMinusIcon } from "./general/minusIcon.svg";
export { default as orangeRightArrow } from "./general/right-arrow-orange.svg";
export { default as shareIcon } from "./general/share.svg";
export { default as shareIconWhite } from "./general/share-icon.svg";
export { default as hamburgerLinkArrow } from "./general/header_right_arrow.svg";
export { default as floatingIcon } from "./general/floating_outer.svg";
export { default as floatingIcon1 } from "./general/floating_inner.svg";
export { default as reseticon } from "./general/reset-icon-orange.svg";
export { default as archinzaChatVideoNew } from "./general/archinza-botdesktopv02.mp4";
export { default as archinzaAIWebVideo } from "./general/archinza-ai-web.mp4";
export { default as imgclose } from "./general/img-delete-icon.svg";
export { default as archinzaLabel } from "./general/archinza-label.svg";
export { default as leftarrowBlack } from "./general/business-left.svg";
export { default as brightarrowBlack } from "./general/business-right.svg";
export { default as errorFailed } from "./general/failed.svg";
export { default as errorFailedWhite } from "./general/failed-white.svg";
export { default as errorSuccess } from "./general/sucess.svg";
export { default as logoutIcon } from "./general/logout.svg";
export { default as shareWhatsappIcon } from "./general/whatsapp_icon.svg";
export { default as shareWhatsappIconWhite } from "./general/whatsapp_icon-white.svg";
export { default as shareLinkedInIcon } from "./general/linkedin_icon.svg";
export { default as shareBlackIcon } from "./general/copy_icon.svg";
export { default as shareBlackInside } from "./general/share_black.svg";
export { default as heartBlack } from "./general/heart_black.svg";
export { default as verifiedBlueIcon } from "./general/verified_blue.svg";
export { default as draftRedIcon } from "./general/draft_red.svg";
export { default as locationOrange } from "./general/location_orange.svg";
export { default as orangeStar } from "./general/orange_star.svg";
export { default as whiteStar } from "./general/orange_star.svg";
export { default as establishedOrange } from "./general/established_orange.svg";
export { default as employeesOrange } from "./general/employees_orange.svg";
export { default as orangeRightTick } from "./general/orange_right_tick.svg";
export { default as editIconBlue } from "./general/edit_icon_blue.svg";
export { default as pdfIcon } from "./general/pdf_icon.svg";
export { default as downloadIcon } from "./general/download_icon.svg";
export { default as modalCloseIcon } from "./general/close_icon_modal.svg";
export { default as closeChipsIcon } from "./general/close_chips.svg";
export { default as dropdownIcon } from "./general/dropdown_icon.svg";
export { default as verifiedIcon } from "./general/verified_icon.svg";
export { default as heartOutline } from "./general/heart_outline.svg";
export { default as writeIcon } from "./general/write_icon.svg";
export { default as mutedVerifIcon } from "./general/verify-icon-muted.svg";
export { default as enhanceProfileicon } from "./general/enhance-profile-icon.svg";
export { default as dropdownIconBlack } from "./general/drop-arrow-black.svg";
export { default as eyeIcon } from "./general/eye-icon.svg";
export { default as blackClose } from "./general/black_close.svg";
export { default as uploadIcon } from "./general/upload_icon.svg";
export { default as logoutBlackIcon } from "./general/logout-black.svg";
export { default as setting } from "./general/setting.svg";
export { default as downarrow } from "./general/downarrow.svg";
export { default as verifiedBlueTick } from "./general/blueTick.svg";
export { default as userOrange } from "./general/userOrange.svg";
export { default as userIconDarkMode } from "./general/userIcon-dark.svg";
export { default as whitelogoBusinessNew } from "./general/archinza-business-logo-new.svg";
export { default as darklogoBusinessNew } from "./general/archinza-business-logo-dark-new.svg";
export { default as xMark } from "./general/x-close.svg";
export { default as settingIcon } from "./general/setting_icon.svg";
export { default as dropdownOrangeIcon } from "./general/dropdown_orange_icon.svg";
export { default as logoutIconBlack } from "./general/logout_icon.svg";
export { default as phonepe } from "./general/phonepe-icon.webp";
export { default as upiLogo } from "./general/UPI_logo.png";
export { default as backArrow } from "./general/back_arrow.svg";
export { default as checkMarkGreen } from "./general/check_mark.svg";
export { default as crossMarkRed } from "./general/cross_mark.svg";
export { default as comingSoonIcon } from "./general/Coming_soon.png";
export { default as whatsAppIconNew } from "./general/whatsapp-icon-new.svg";
export { default as whatsAppIconInner } from "./general/whatsapp_icon_inner.svg";
export { default as forBusinessHeaderLogo } from "./general/Archinza_ForBusiness_Header_logo.svg";
export { default as forBusinessHeaderLogoHover } from "./general/Archinza_ForBusiness_Header_logo_hover.svg";
export { default as forBusinessHeaderLogoDark } from "./general/Archinza_ForBusiness_Header_logo_DarkTheme.svg";

// Business Connect Images
export { default as workplace01 } from "./BusinessConnect/workplace1.png";
export { default as groupImageIcon } from "./BusinessConnect/group_Image_icon.png";
export { default as facebookIconOrange } from "./BusinessConnect/facebook_icon_orange.png";
export { default as webIconOrange } from "./BusinessConnect/web_icon_orange.png";
export { default as webIcon } from "./BusinessConnect/web_icon.svg";
export { default as webIconDark } from "./BusinessConnect/web_icon_dark.svg";
export { default as linkedInIcon } from "./BusinessConnect/linkedIn_icon.svg";
export { default as linkedInIconDark } from "./BusinessConnect/linkedIn_icon_dark.svg";
export { default as instaIcon } from "./BusinessConnect/insta_icon.svg";
export { default as instaIconDark } from "./BusinessConnect/insta_icon_dark.svg";

// Gallery Images
export { default as eyeCloseBlue } from "./GalleryImages/eye_close_blue_icon.svg";
export { default as eyeCloseBlack } from "./GalleryImages/eye_close_black.svg";
export { default as pinIocn } from "./GalleryImages/pin-orange.svg";
export { default as moveIocn } from "./GalleryImages/move-icon-orange.svg";
export { default as eyeClose } from "./GalleryImages/eye-close-orange.svg";
export { default as eyeCloseDark } from "./GalleryImages/eye-close-orange-dark.svg";
export { default as eyeOpen } from "./GalleryImages/eye-open-orange.svg";
export { default as eyeOpenDark } from "./GalleryImages/eye-open-orange-dark.svg";
export { default as menuDotsIcon } from "./GalleryImages/menu_dots.svg";
export { default as addIconGallery } from "./GalleryImages/add-icon.svg";
export { default as gallery1 } from "./GalleryImages/gallery-one.png";
export { default as gallery2 } from "./GalleryImages/gallery_two.png";
export { default as gallery3 } from "./GalleryImages/gallery_three.png";
export { default as gallery4 } from "./GalleryImages/gallery_4.png";
export { default as gallery5 } from "./GalleryImages/gallery_5.png";
export { default as gallery6 } from "./GalleryImages/gallery_6.png";
export { default as gallery7 } from "./GalleryImages/gallery_7.png";
export { default as gallery8 } from "./GalleryImages/gallery_8.png";
export { default as gallery9 } from "./GalleryImages/gallery_9.png";
export { default as gallery10 } from "./GalleryImages/gallery_10.png";
export { default as gallery11 } from "./GalleryImages/gallery_11.png";
export { default as gallery12 } from "./GalleryImages/gallery_12.png";
export { default as clsoeIconActionIcon } from "./GalleryImages/cross_gallery_icon.svg";
export { default as pinIconActionIcon } from "./GalleryImages/pin_gallery_icon.svg";
export { default as hideShowActionIcon } from "./GalleryImages/hideshow_gallery_icon.svg";
export { default as DeleteActionIcon } from "./GalleryImages/delete_gallery_icon.svg";
export { default as MoveActionIcon } from "./GalleryImages/move_gallery_icon.svg";

// homepage
export { default as logo } from "../images/homepage/archinza_logo_2.png";
export { default as mbLogo } from "../images/homepage/mb_archinza_logo_2.png";
export { default as homepageBanner } from "../images/homepage/banner_1.png";
export { default as mbHomepageBanner } from "../images/homepage/mb_banner_1.png";
export { default as chatImg } from "../images/homepage/chat_img_3.png";
export { default as mbChatImg } from "../images/homepage/mb_chat_img_3.png";
export { default as facebook } from "../images/homepage/facebook.png";
export { default as linkedIn } from "../images/homepage/linkedin.png";
export { default as insta } from "../images/homepage/insta.png";
export { default as searchIcon } from "../images/homepage/search-icon.svg";
export { default as reachIcon } from "../images/homepage/reach-icon.svg";
export { default as connectIcon } from "../images/homepage/connect-icon.svg";
export { default as askIcon } from "../images/homepage/ask.svg";
export { default as chatStep01 } from "../images/homepage/step_1.svg";
export { default as chatStep02 } from "../images/homepage/step_2.svg";
export { default as chatStep03 } from "../images/homepage/step_3.svg";
export { default as perkLeftArrow } from "../images/homepage/perk_left_arrow.svg";
export { default as perkRightArrow } from "../images/homepage/perk_right_arrow.svg";

// dashboard page
export { default as dashboardCall } from "../images/dashboard/call_icon.png";
export { default as dashboardEmail } from "../images/dashboard/email_icon.png";
export { default as dashboardLocation } from "../images/dashboard/location_icon.png";
export { default as dashboardEdit } from "../images/dashboard/edit_icon.png";
export { default as contactBg } from "../images/dashboard/contact_background.png";
export { default as editicon } from "../images/dashboard/edit-icon.svg";
export { default as editiconwhite } from "../images/dashboard/edit-icon-white.svg";
export { default as editiconorange } from "../images/dashboard/edit-icon-orange.svg";
export { default as changeRoleCup } from "../images/dashboard/cup.svg";
export { default as instantIcon } from "../images/dashboard/instant-icon.svg";
export { default as calendarIcon } from "../images/dashboard/calendar-icon.svg";
export { default as jobIcon } from "../images/dashboard/job-icon.svg";
export { default as bbicon } from "../images/dashboard/bb-icon.png";
export { default as dashedline } from "../images/dashboard/dashed-line.svg";

// registration form page
export { default as lightthemebackground } from "../images/registrationform/light-theme-background.png";
export { default as catalougeDelete } from "../images/registrationform/delete-icon.svg";

// about us page
export { default as aboutWhiteBanner } from "../images/about/about us - white banner-01.jpg";
export { default as collaborator1 } from "../images/about/ToggleheadMainLogoOrange.png";
export { default as collaborator2 } from "../images/about/One Digital.png";
export { default as collaborator3 } from "../images/about/Comportement-White.png";
export { default as collaborator2Black } from "../images/about/one digital - black-01.png";
export { default as collaborator3Black } from "../images/about/comportement - black-01.png";
export { default as collaborator4 } from "../images/about/Haptik.png";
export { default as collaborator5 } from "../images/about/DanitTech.png";
export { default as collaborator6 } from "../images/about/CA India Logo.png";
export { default as Hustlers1 } from "../images/about/card-1-Our Hustlers.png";
export { default as Hustlers2 } from "../images/about/card-2-Our Hustlers.png";
export { default as Hustlers3 } from "../images/about/card-3-Our Hustlers.png";
export { default as Hustlers4 } from "../images/about/card-4-Our Hustlers.png";
export { default as Hustlers5 } from "../images/about/card-5-Our Hustlers.png";
export { default as Hustlers6 } from "../images/about/card-6-Our Hustlers.png";
export { default as Hustlers7 } from "../images/about/card-7-Our Hustlers.png";
export { default as Hustlers8 } from "../images/about/card-8-Our Hustlers.png";
export { default as Hustlers9 } from "../images/about/card-9-Our Hustlers.png";
export { default as aboutBuildingStructure } from "../images/about/about-building-structure.png";
export { default as aboutBgMob } from "../images/about/about_v2_bg_mob.png";
export { default as aboutBgDesk } from "../images/about/about_v2_bg_desktop.png";
export { default as archeryLogoMob } from "../images/about/archery_mob.svg";
export { default as archeryLogo } from "../images/about/archery.svg";
export { default as aboutBannerV2 } from "../images/about/about-banner.png";
export { default as aboutBanner } from "../images/about/aboutus_banner.jpg";
export { default as whoLinkedIn } from "../images/about/linkedIn.svg";
export { default as natashaKochhar } from "../images/about/Natasha_Kochhar.png";
export { default as colaboratoImg } from "../images/about/colab-image.png";
export { default as dummy } from "../images/about/dummy.png";
export { default as dummy2 } from "../images/about/dummy2.png";
export { default as sliderBlurLeft } from "../images/about/sliderBlurLeft.svg";
export { default as sliderBlurRight } from "../images/about/sliderBlurRight.svg";
export { default as sliderLeftNav } from "../images/about/slider-left-nav.svg";
export { default as sliderRightNav } from "../images/about/slider-right-nav.svg";
export { default as SwapanFB } from "../images/about/swapan.png";
export { default as NishitFB } from "../images/about/nishit.png";
export { default as KrishFB } from "../images/about/krish.png";
export { default as PrashaantKochharFB } from "../images/about/Prashaant_Kochhar.png";
export { default as UpharChibberFB } from "../images/about/Uphar_Chibber.png";

// contact us page
export { default as contactBanner } from "../images/contactus/contact_us_banner_1.jpg";
export { default as contactBannerWhite } from "../images/contactus/contact us-white-banner-01.jpg";

// faqs page
export { default as faqsBanner } from "../images/faqs/faqs_banner.jpg";
export { default as faqsBannerWhite } from "../images/faqs/faq-white-banner-01.jpg";

// blogs listing page
export { default as blogsListing } from "../images/blogs/blogsListing_banner.png";
export { default as rightArrowBlue } from "../images/blogs/right-arrow-blue.svg";

// blogs inner page
export { default as blogsInner } from "../images/blogs/blogsListing_banner.png";
export { default as blogsShareIcon } from "../images/blogs/share.svg";

// congratulations page
export { default as congraDesktopBanner } from "../images/congratulations/congrats_desktop_banner.jpg";
export { default as congraMobileBanner } from "../images/congratulations/congrats_mobile_banner.jpg";
export { default as congratCup } from "../images/congratulations/cup.svg";
export { default as congratCupWhite } from "../images/congratulations/cup_white.svg";

export { default as logoedit } from "../images/BusinessProfile/logo-edit.svg";
export { default as greentick } from "../images/BusinessProfile/green-tick.svg";
export { default as whitetick } from "../images/BusinessProfile/white-tick.svg";
export { default as websiteiconb } from "../images/BusinessProfile/website-icon-b.svg";
export { default as linkediniconb } from "../images/BusinessProfile/linkedin-iconb.svg";
export { default as fbiconb } from "../images/BusinessProfile/fb-iconb.svg";
export { default as behanceiconb } from "../images/BusinessProfile/behance-iconb.svg";
export { default as addmoreIcon } from "../images/BusinessProfile/add-plus-icon.svg";
export { default as closeIcon } from "../images/BusinessProfile/close-icon.svg";
export { default as bookmarkIcon } from "../images/BusinessProfile/bookmark_icon.svg";
export { default as beleftarrow } from "../images/BusinessProfile/be-left-arrow.svg";
export { default as berightarrow } from "../images/BusinessProfile/be-right-arrow.svg";
export { default as deleteiconcircle } from "../images/BusinessProfile/delete-icon-circle.svg";

// Business Profile View
export { default as ConnectIcon } from "../images/BusinessEditProfile/connect_icon.svg";
export { default as msgIcon } from "../images/BusinessEditProfile/msg_icon.svg";
export { default as supporterPlan } from "../images/BusinessEditProfile/supporter_plan.png";
export { default as starterPlan } from "../images/BusinessEditProfile/starter_plan.png";

// business category
export { default as geometryIcon } from "../images/BusinessProfile/geometry.svg";
export { default as constructin_icon } from "../images/BusinessProfile/constructin_icon.svg";
export { default as retail_icon } from "../images/BusinessProfile/retail_icon.svg";
export { default as manufacture_icon } from "../images/BusinessProfile/manufacture_icon.svg";
export { default as marketing_icon } from "../images/BusinessProfile/marketing_icon.svg";
export { default as selected_card_bg } from "../images/BusinessProfile/selected_card_bg.png";

// Business Profile Edit
export { default as Aura } from "../images/BusinessEditProfile/Aura-cta-video.mp4";
export { default as lockIcon } from "../images/BusinessEditProfile/lock-icon.svg";
export { default as pdfImagePreview } from "../images/BusinessEditProfile/pdf_image_preview.png";
export { default as infoIconEditProfile } from "../images/BusinessEditProfile/info_icon_edit_profile.svg";
export { default as prmoteIcon } from "../images/BusinessEditProfile/promote_icon.svg";
export { default as prmoteIconDiable } from "../images/BusinessEditProfile/promote_disable_icon.svg";
export { default as enhanceProfileIconStar } from "../images/BusinessEditProfile/enhance-profile-icon.svg";
export { default as demoPdf } from "../images/BusinessEditProfile/demo.pdf";
export { default as laura_adai } from "../images/BusinessEditProfile/laura_adai.png";
export { default as albero_furniture } from "../images/BusinessEditProfile/albero_furniture.png";
export { default as kenny_eliason } from "../images/BusinessEditProfile/kenny_eliason.png";
export { default as bEdit_background } from "../images/BusinessEditProfile/bEdit_background.svg";
export let images = {
  archinzaFormBg: {
    image: require("./general/archinza-form-bg.png"),
    alt: "form bg",
  },
  formBg: {
    image: require("./general/form-bg.jpg"),
    alt: "bg",
  },
  editProfileBG: {
    image: require("./general/edit-back.jpg"),
    alt: "edit profile bg",
  },
  teammemberBg: {
    image: require("./teammember/team-member-bg.jpg"),
    alt: "Working Professional bg",
  },
  homeBg: {
    image: require("./homepage/home-bg.jpg"),
    alt: "home bg",
  },
  mannequeenImg: {
    image: require("./homepage/mannequeen.png"),
    alt: "mannequeen",
  },
  PD633x915: {
    image: require("./homepage/633x915PD.png"),
    alt: "PD633915",
  },
  social1: {
    image: require("./homepage/social-1.png"),
    alt: "social",
  },
  social2: {
    image: require("./homepage/social-2.png"),
    alt: "social",
  },
  social3: {
    image: require("./homepage/social-3.png"),
    alt: "social",
  },
  social4: {
    image: require("./homepage/social-4.png"),
    alt: "social",
  },
  blogListing1: {
    image: require("./blogs/luke-van.png"),
    alt: "blogs",
  },
  blogListing2: {
    image: require("./blogs/ricardo-gomez.png"),
    alt: "blogs",
  },
  blogListing3: {
    image: require("./blogs/lance-anderson.png"),
    alt: "blogs",
  },
  hero1: {
    image: require("./blogs/luke-van-zyl-blogs-inner.png"),
    alt: "blogs",
  },
  businessprifilebg: {
    image: require("./BusinessProfile/business-prifile-bg.jpg"),
    alt: "business prifile bg",
  },
  brandlogo: {
    image: require("./BusinessProfile/brand-logo.png"),
    alt: "brand logo",
  },
  projectGallery01: {
    image: require("./BusinessProfile/project-gallery-01.jpg"),
    alt: "project gallery 01",
  },

  // DASHBOARD IMAGES
  dashboardcountbg: {
    image: require("./dashboard/dashboard-count-bg.jpg"),
    alt: "dashboard count bg",
  },

  // Business Profile Edit
  businessGallery00: {
    image: require("./BusinessEditProfile/the_artwill.png"),
    alt: "the_artwill",
  },
  businessGallery01: {
    image: require("./BusinessEditProfile/the-artwill.png"),
    alt: "the-artwill",
  },
  businessGallery02: {
    image: require("./BusinessEditProfile/ali-moradi.png"),
    alt: "the-artwill",
  },
  businessGallery03: {
    image: require("./BusinessEditProfile/thufeil-m.png"),
    alt: "the-artwill",
  },
  businessGallery04: {
    image: require("./BusinessEditProfile/laura-adai.png"),
    alt: "the-artwill",
  },
  businessGallery05: {
    image: require("./BusinessEditProfile/bilal-mansuri.png"),
    alt: "the-artwill",
  },
  // businessGallery06: {
  //   image: require("./BusinessEditProfile/laura_adai.png"),
  //   alt: "laura_adai",
  // },
  // businessGallery07: {
  //   image: require("./BusinessEditProfile/albero_furniture.png"),
  //   alt: "albero_furniture",
  // },

  rating01: {
    image: require("./BusinessEditProfile/rating_thumb.png"),
    alt: "the-artwill",
  },
};
